import { StandingConsentAcceptanceHintsDto } from '@shared/core/events'
import classNames from 'classnames'
import Tooltip from 'rc-tooltip'
import { useIntl } from 'react-intl'
import { FormattedText, ToggleSwitch, Typography } from 'src/modules/core/components'
import { createRcTooltipPlacements, RC_TOOLTIP_GAP_PX } from 'src/modules/core/utils/create-rc-tooltip-placements'
import classes from './event-card-phone-fields.module.scss'

export type EventCardBulkAutoActivateSwitchProps = {
  standingConsentCandidates: string[]
  bulkAutoActivate: boolean
  bulkAutoActivateTouched: boolean
  standingConsentHints?: StandingConsentAcceptanceHintsDto
  onChange: (checked: boolean) => void
}

export function EventCardBulkAutoActivateSwitch({
  standingConsentCandidates,
  bulkAutoActivate,
  bulkAutoActivateTouched,
  onChange,
}: EventCardBulkAutoActivateSwitchProps) {
  const { formatMessage } = useIntl()

  const tooltipBase = formatMessage(
    { id: 'autoActivation.standingConsent.eventCardTooltip' },
    { count: standingConsentCandidates.length },
  )

  const showLabelShimmer = standingConsentCandidates.length > 0 && !bulkAutoActivate && !bulkAutoActivateTouched

  return (
    <div className={classes.bulkAutoActivateRow}>
      <Tooltip
        placement="top"
        mouseEnterDelay={0.8}
        builtinPlacements={createRcTooltipPlacements(RC_TOOLTIP_GAP_PX)}
        trigger={['hover', 'focus']}
        overlay={
          <Typography variant="span" className={classes.standingConsentTooltipText}>
            <FormattedText
              id="autoActivation.standingConsent.eventCardTooltip"
              values={{ count: standingConsentCandidates.length }}
            />
          </Typography>
        }
        overlayClassName={classes.tooltipOverlay}
      >
        <div className={classes.standingConsentControls} data-testid="event-card-bulk-auto-activate">
          <span className={classes.standingConsentToggleLabelTrigger} tabIndex={0} aria-label={tooltipBase}>
            <Typography
              variant="body"
              className={classNames(classes.standingConsentToggleLabel, {
                [classes.standingConsentToggleLabelShimmer]: showLabelShimmer,
              })}
            >
              <FormattedText id="autoActivation.standingConsent.toggleLabel" />
            </Typography>
          </span>
          <ToggleSwitch
            id="event-card-bulk-auto-activate"
            checked={bulkAutoActivate}
            onChange={(changeEvent) => onChange((changeEvent.target as HTMLInputElement).checked)}
            data-testid="event-card-bulk-auto-activate-toggle"
          />
        </div>
      </Tooltip>
    </div>
  )
}
